import { getDeploymentConfig } from "./deployment-config";

// Counts this page load in the central visitor log (api/src/visitors.rs):
// the shared API Gateway's access log records every request's address, but
// someone playing without signing in calls nothing else. Fire and forget; a
// local dev server doesn't count.
export function recordVisit() {
  if (["localhost", "127.0.0.1"].includes(window.location.hostname)) return;
  void fetch(`${getDeploymentConfig().apiUrl}/visit`, { method: "POST", mode: "no-cors", keepalive: true }).catch(() => {});
}
